import React from "react";
import { Box } from "@mui/material";
import { colors } from "../../../utils/constants";
import { landingTokens } from "../theme";

interface IconBadgeProps {
  icon: React.ReactNode;
  size?: number;
}

function IconBadge({ icon, size = 56 }: IconBadgeProps) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: `${landingTokens.radius.badge}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#EAF4FF",
        color: colors.primary,
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
  );
}

export default IconBadge;
